import type { DragType } from "@v1/types/drag-type";
import type * as React from "react";
import type { EditorCanvas } from "replo-utils/lib/misc/canvas";
import type { CanvasFrameRefs } from "./canvas-types";

import { createContext } from "replo-utils/react/context";

interface CanvasContextValue {
  canvas: EditorCanvas;
  canvasHeight: number;
  canvasWidth: number;
  frameWidth: number;
  targetFrame: HTMLIFrameElement | null;
  canvasTopOffset: number;
  canvasLeftOffset: number;
  canvasBottomOffset: number;
}

export const CanvasContext = createContext<CanvasContextValue>("CanvasContext");

interface CanvasAreaContextValue {
  currentDragType: DragType | null;
  canvasHtml: string | null;
  frameRefs: React.MutableRefObject<CanvasFrameRefs>;
}

export const CanvasAreaContext =
  createContext<CanvasAreaContextValue>("CanvasAreaContext");
